module.exports = __webpack_public_path__ + "static/media/btx_locked.b8272786.svg";